/**
 * Detects card type from card number
 * Based on legacy PaymentProcessorUtility.getCardType
 */
export function detectCardType(cardNumber) {
  if (!cardNumber || cardNumber.length < 13) return "Unknown";

  const stripped = cardNumber.replace(/\s/g, "").replace(/-/g, "");

  // Visa: starts with 4, length 13 or 16
  if (stripped[0] === "4" && (stripped.length === 13 || stripped.length === 16)) {
    return "Visa";
  }

  // MasterCard: starts with 51-55, length 16
  const first2 = parseInt(stripped.substring(0, 2), 10);
  if (first2 >= 51 && first2 <= 55 && stripped.length === 16) {
    return "Mastercard";
  }

  // Discover: starts with 65 or 6011, length 16
  if ((stripped.substring(0, 2) === "65" || stripped.substring(0, 4) === "6011") && stripped.length === 16) {
    return "Discover";
  }

  // Amex: starts with 34 or 37, length 15
  if ((stripped.substring(0, 2) === "34" || stripped.substring(0, 2) === "37") && stripped.length === 15) {
    return "Amex";
  }

  return "Unknown";
}

/**
 * Gets card image class for displaying card type visually
 */
export function getCardImageClass(cardType) {
  const typeMap = {
    Visa: "visa",
    Mastercard: "mastercard",
    Discover: "discover",
    Amex: "amex",
  };
  return typeMap[cardType] || "generic";
}

/**
 * Formats card number with spaces (e.g., "4111 1111 1111 1111")
 */
export function formatCardNumber(cardNumber) {
  if (!cardNumber) return "";
  const stripped = cardNumber.replace(/\s/g, "").replace(/-/g, "");
  const groups = stripped.match(/.{1,4}/g) || [];
  return groups.join(" ");
}

/**
 * Auto-formats an expiry input into MM/YY as the user types.
 * - Strips non-digits
 * - Clamps month to 01–12
 * - Auto-inserts "/" after the month
 * - Limits to 5 characters (MM/YY)
 */
export function formatExpiry(raw) {
  const digits = raw.replace(/\D/g, "").slice(0, 6); // allow up to 6 digits (MMYYYY)

  if (digits.length === 0) return "";

  // Clamp first digit: only 0 or 1 valid for months
  let month = digits.slice(0, 2);
  if (digits.length === 1) {
    // If first digit > 1, it can only be a single-digit month (e.g. "9" → "09")
    if (parseInt(digits[0], 10) > 1) {
      month = "0" + digits[0];
    } else {
      return month; // still typing, e.g. "1"
    }
  }

  // Clamp month 00→01, 13+→12
  const monthNum = parseInt(month, 10);
  if (monthNum === 0) month = "01";
  else if (monthNum > 12) month = "12";

  const year = digits.slice(2, 4); // take only YY (first 2 year digits)
  if (!year) return month;

  return `${month}/${year}`;
}

/**
 * Generates auto profile name from card type and last 4 digits
 * E.g., "Visa-1111"
 */
export function generateProfileName(cardNumber, cardType) {
  if (!cardNumber || !cardType || cardType === "Unknown") return "";
  const lastFour = cardNumber.replace(/\s/g, "").replace(/-/g, "").slice(-4);
  return `${cardType}-${lastFour}`;
}
